module.exports = __webpack_public_path__ + "img/baseline-add_location-24px.54822f35.svg";